import { colors } from '../../colors';
var location = {
  bgColor: colors.whiteish,
  secondaryBgColor: colors.white,
  cardBgColor: colors.white,
  cardShadow: colors.black
};
export default location;